import { useCallback, useEffect, useState } from 'react';

import { isValidErrors, useValidatedForm } from 'src/lib/hooks';
import { RULES } from 'src/lib/validation';

export const useViewModel = ({ onSubmit, error }) => {
  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = useCallback(() => {
    setShowPassword((prev) => !prev);
  }, []);
  const [showErrors, setShowErrors] = useState(true);

  // If we receive new 'error' - show it
  useEffect(() => {
    if (error) {
      setShowErrors(true);
    }
  }, [error]);

  // Form state
  const {
    fields: formFields,
    errors: formErrors,
    validateWithRules: validateForm,
    update: updateForm,
  } = useValidatedForm({
    initialFields: {
      email: '',
      password: '',
    },
    rules: {
      email: {
        [RULES.required]: { message: 'Please enter your email address' },
      },
      password: { [RULES.required]: { message: 'Please enter your password' } },
    },
  });

  // Run authentication
  const handleSubmit = useCallback(
    (event) => {
      event.preventDefault();

      setShowErrors(true);
      const validations = validateForm();
      if (!isValidErrors(validations)) {
        return;
      }

      onSubmit(formFields.email.trim(), formFields.password.trim());
    },
    [validateForm, onSubmit, formFields.email, formFields.password]
  );

  const updateField = useCallback(
    (field, value) => {
      setShowErrors(false);
      updateForm(field, value);
    },
    [updateForm]
  );

  return {
    handleSubmit,
    showErrors,
    formFields,
    updateField,
    formErrors,
    showPassword,
    toggleShowPassword,
  };
};
